const authData = {
    email: 'cmk2020@ujk.edu.pl',
    password: 'CMK2020!auto',
    returnSecureToken: true
}

export default authData;